import { useState, useRef } from "react";
import MinusIcon from "../formnavigation/MinusIcon";
import PlusIcon from "../formnavigation/PlusIcon";
import * as theme from "../theme";

const CmnGroupHeader = ({
  isComplete,
  isOpen,
  text,
  isFirstGroup,
  isLastGroup,
  handleOnClick,
  allinonepage,
  htmlid,
}) => {
  const [focus, setFocus] = useState(false);
  const headerRef = useRef(null);
  const CmnGrpHeaderClickHandler = () => {
    if (!isOpen) {
      //the group isnt open yet lets scroll into view
      setTimeout(() => {
        headerRef.current.scrollIntoView();
      }, 100);
    }
    handleOnClick();
  };
  return (
    <div
      onClick={CmnGrpHeaderClickHandler}
      ref={headerRef}
      tabIndex={0}
      id={htmlid}
      style={{
        display: "flex",
        alignItems: "center",
        paddingLeft: "7%",
        paddingRight: "5%",
        justifyContent: "space-between",
        width: "100%",
        height: theme.SCALES.groupTabMinHeight,
        backgroundColor: focus
          ? theme.COLORS.secondary_orange
          : isOpen
          ? theme.COLORS.navigation_header_tab
          : isComplete
          ? theme.COLORS.group_tab_header_completed
          : theme.COLORS.group_tab_header_incomplete,
        fontFamily: "GibsonLight",
        color: "white",
        letterSpacing: 1.3,
        fontWeight: "bold",
        borderBottom: `1px solid ${theme.COLORS.group_inbetween_border}`,
        fontSize: "1.8vmin",
        borderTopLeftRadius: isFirstGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
        borderTopRightRadius: isFirstGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
        borderBottomLeftRadius: isOpen
          ? 0
          : isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
        borderBottomRightRadius: isOpen
          ? 0
          : isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,

        cursor: "pointer",
      }}
      onFocus={() => {
        setFocus(true);
      }}
      onBlur={() => {
        setFocus(false);
      }}
      onKeyPress={(event) => {
        if (event.key === "Enter" || event.key === " ") handleOnClick();
      }}
    >
      {text}
      {allinonepage ? (
        isOpen ? (
          <MinusIcon></MinusIcon>
        ) : (
          <PlusIcon></PlusIcon>
        )
      ) : null}
    </div>
  );
};

export default CmnGroupHeader;
